import { gql } from '@apollo/client';

export const DELETE_COURSE_MUTATION = gql`
    mutation deleteCourse($courseID: UUID!) {
        result: deleteCourse(courseID: $courseID) {
            affectedRows
        }
    }
`;
